import type { ArcManifest } from '@/core/ArcRegistry';
import { SPECIES } from '@/entities/species';

export const UNDERCITY_ARC: ArcManifest = {
  id: 'undercity',
  displayName: 'arc.undercity.name',
  description: 'arc.undercity.description',
  entryScene: 'UnderCity',
  unlockedBy: { type: 'always' },

  species: SPECIES,

  relationOverrides: [
    // Alligator is a predator to the blob until tier-6 biomass
    { speciesId: 'alligator', relation: 'PREDATOR', when: (p) => p.mass < 120 },
    // Humans are always predators in Act 0 — shoe-slap instakill
    { speciesId: 'human', relation: 'PREDATOR' },
  ],

  abilityUnlockRules: [
    { abilityId: 'scent-trails', speciesId: 'cockroach', count: 5 },
    { abilityId: 'sludge-resilience', speciesId: 'larva', count: 4 },
    { abilityId: 'vermin-cunning', speciesId: 'rat', count: 3 },
    { abilityId: 'feline-stealth', speciesId: 'cat', count: 1 },
    { abilityId: 'burst-speed', speciesId: 'alligator', count: 1 },
  ],

  brainQualityFor: (speciesId) => SPECIES[speciesId]?.brainQuality,

  localeBundle: {
    'arc.undercity.name': 'The Undercity',
    'arc.undercity.description':
      'A decommissioned sewer beneath the rubber plant. You escaped a lab upstairs. You are very small. Most things can kill you by accident.',
    'narrator.intro': '[dark. warm. wet. acceptable.]',
    'narrator.tier.2': '[more.]',
    'narrator.tier.3': '[the world shrinks.]',
    'narrator.tier.4': '[the boots do not find me.]',
    'narrator.tier.5': '[I hunger for what hunts me.]',
    'narrator.tier.6': '[I am ready.]',
    'narrator.brain.1': '[hunger.]',
    'narrator.brain.2': '[hide. warm. hungry.]',
    'narrator.brain.3': '[the rat. I am larger. I eat.]',
    'narrator.brain.4': '[I see myself for the first time.]',
  },
};
